<template>
    <div class="doc-section">
        <h1>
            Editar Dispositivo
        </h1>
         <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <p>
            Para modificar los datos de un dispositivo existente, hacer clic en el ícono “Editar” mostrado en la columna
            Acciones y correspondiente al dispositivo que se desea editar, Esto cargará el formulario Editar Dispositivo
            con los datos guardados en sistema del dispositivo seleccionado
        </p>

        <h2></h2>
        <p>
            Si seleccionó un dispositivo con modelo TKSTAR, por lo que uno de los campos que se muestra
            para edición es el campo ID*, sin embargo, si se selecciona un modelo TK108, el campo que en la imagen
            anterior se muestra como ID*, cambiará su descripción a IMEI*, como se aprecia a continuación
        </p>
        <p>
            Posterior a modificar los datos requeridos, se puede seleccionar una de las dos opciones disponibles a
            través de dar clic en un botón
        </p>
        <ol class="ul-contenedor step-list">
            <li>Botón “Cancelar”. Cierra el formulario de edición y nos devuelve a la vista Dispositivos sin guardar los
                cambios realizados.</li>
            <li>Botón “Guardar dispositivo”. Valida los datos que se ingresaron en el formulario y, de ser correctos,
                actualiza el registro del dispositivo. Cierra el formulario de edición y nos devuelve a la vista
                Dispositivos en donde se podrá apreciar el dispositivo con los datos actualizados.</li>
        </ol>

        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenes" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesMoviles" />
        </div>
    </div>
</template>




<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'EditarDispositivo',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenes: [
            {
                nombre: "Formulario Editar Dispositivo",
                url: "img/Dispositivos/formularioEditarDispositivo.png",
                descripcion: ""
            },
           
        ],

        imagenesMoviles: [
            {
                nombre: "Formulario Editar Dispositivo",
                url: "img/Dispositivos/moviles/formularioEditarDispositivo.png",
                descripcion: ""
            },
           
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>